import React from "react";
import { withTranslation } from "react-i18next";
import { Form, Input, Popover, Typography } from "antd";
import { CustomInput } from "../customComponent/CustomInput";

const { TextArea } = Input;
const { Text } = Typography;

const NoteFormItemComponent = ({
  t,
  style,
  label,
  textArea = false,
  rows = 4,
  required = true,
  editable = true,
  showLabel = false,
  strong = false,
  dataTMId,
  id
}) => (
  <Popover placement="top" content={t("form.note.popover")} trigger="hover" overlayStyle={{ width: 250 }}>
    <Form.Item
      name="note"
      colon={false}
      label={showLabel ? <Text strong={strong}>{label ? label : t("form.note.label")}</Text> : null}
      rules={[{ required, message: t("form.note.error_required") }]}
      style={style}
    >
      {textArea ? (
        <TextArea data-tm-id={dataTMId} rows={rows} />
      ) : (
        <CustomInput id={id} data-tm-id={dataTMId} disabled={!editable} placeholder={t("form.note.placeholder")} />
      )}
    </Form.Item>
  </Popover>
);

const NoteFormItem = withTranslation()(NoteFormItemComponent);

export { NoteFormItem };
